'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _ = require('lodash');
var toastr = require('toastr');
var _require = require('prop-types'),
  func = _require.func;
var ConfigurationFoCityAptsService = function ConfigurationFoCityAptsService(fileSaveService, momentService, configurationService, restangular, $q, $http, commonUiConstants, advancedGridReloadConfigurationCacheCityAptsService) {
  var updateBulkFoCityAptsService = restangular.service('external').one('faresoptimizer').one('focityapts').one('bulk');
  function exportToCsv(data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', 'FOCityApts.csv');
  }
  function createCsvHeader() {
    return formatAsCsvRow(['Carrier', 'Origin', 'Destination', 'City', 'Airport', 'Routing']);
  }
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function createCsvRow(row) {
    return formatAsCsvRow([_.isNil(row.carrier) ? '' : row.carrier.toUpperCase(), row.originAirport, row.destinationAirport, row.city, row.airport, row.routing]);
  }
  function remove(rows, gridData, rowIndicesToBeRemoved) {
    var groupedByAction = getDataPartitionedByIndicesPresence(gridData, rowIndicesToBeRemoved);
    var groupedRowsToBeDeleted = getDataGroupedByKey(groupedByAction.rowsToBeRemoved);
    var groupedRowsToBeRetained = getDataGroupedByKey(groupedByAction.rowsToBeRetained);
    var keysToBeDeleted = Object.keys(groupedRowsToBeDeleted);
    var keysToBeRetained = Object.keys(groupedRowsToBeRetained);
    var commonKeys = getCommonKeys(keysToBeRetained, keysToBeDeleted);
    var groupedDataHavingMatchingKeys = getDataForMatchingKeys(groupedRowsToBeRetained, commonKeys);
    var groupedDataHavingNonMatchingKeys = getDataForNonMatchingKeys(groupedRowsToBeDeleted, commonKeys);
    var payloadToBeUpdated = getTransformedCityAptsListPayload(groupedDataHavingMatchingKeys);
    payloadToBeUpdated = buildFinalPayloads(payloadToBeUpdated);
    var payloadToBeDeleted = getTransformedCityAptsListPayload(groupedDataHavingNonMatchingKeys);
    payloadToBeDeleted = buildFinalPayloads(payloadToBeDeleted);
    return savePayload(payloadToBeUpdated).then(deleteFromServer(payloadToBeDeleted));
  }
  function getDataPartitionedByIndicesPresence(gridData, rowIndicesToBeRemoved) {
    var rowsToBeRemoved = [];
    var rowsToBeRetained = [];
    _.forEach(gridData, function (value, index) {
      if (_.includes(rowIndicesToBeRemoved, index)) {
        rowsToBeRemoved.push(value);
      } else {
        rowsToBeRetained.push(value);
      }
    });
    return {
      rowsToBeRemoved: rowsToBeRemoved,
      rowsToBeRetained: rowsToBeRetained
    };
  }
  function getDataForMatchingKeys(groupedRowsToBeRetained, keys) {
    var matchingKeyObj = {};
    var allKeys = Object.keys(groupedRowsToBeRetained);
    _.forEach(allKeys, function (key) {
      if (keys.includes(key)) {
        matchingKeyObj[key] = groupedRowsToBeRetained[key];
      }
    });
    return matchingKeyObj;
  }
  function getDataForNonMatchingKeys(groupedRowsToBeDeleted, keys) {
    var nonMatchingKeyObj = {};
    var allKeys = Object.keys(groupedRowsToBeDeleted);
    _.forEach(allKeys, function (key) {
      if (!keys.includes(key)) {
        nonMatchingKeyObj[key] = groupedRowsToBeDeleted[key];
      }
    });
    return nonMatchingKeyObj;
  }
  function deleteFromServer(payloads) {
    var httpContent = _.map(payloads, function (payload) {
      return $http({
        method: 'DELETE',
        url: '/api/external/faresoptimizer/focityapts',
        data: payload,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      });
    });
    return $q.all(httpContent).then(deleteSuccessCallBack);
  }
  function deleteSuccessCallBack(response) {
    advancedGridReloadConfigurationCacheCityAptsService.reloadCityApts();
    return response;
  }
  function validate(editedRows, gridData) {
    for (var i = 0; i < editedRows.length; i++) {
      if (hasDuplicateEntry(editedRows[i], gridData)) {
        toastr.error('Duplicate/Overlapping rows Identified for ' + getCityAptsKey(editedRows[i]));
        return false;
      }
    }
    return true;
  }
  function hasDuplicateEntry(newEntry, allRows) {
    var newEntryKey = getCityAptsKey(newEntry);
    var allRowsKeys = _.chain(allRows).map(function (row) {
      return getCityAptsKey(row);
    }).value();
    return allRowsKeys.reduce(function (count, keys) {
      return keys === newEntryKey ? count + 1 : count;
    }, 0) > 1;
  }
  function save(editedRows, gridData) {
    var rowsForDeletion = [];
    _.forEach(editedRows, function (editedRow) {
      if (_.has(editedRow, '_old') && !_.has(editedRow, 'isNewlyAdded')) {
        var rowForDeletion = buildPayLoadForRemovalWhileSaving(editedRow);
        if (rowForDeletion.origin === undefined || rowForDeletion.origin === null) {
          rowForDeletion.origin = '';
        }
        if (rowForDeletion.destination === undefined || rowForDeletion.destination === null) {
          rowForDeletion.destination = '';
        }
        if (rowForDeletion.routing === undefined || rowForDeletion.routing === null) {
          rowForDeletion.routing = null;
        }
        rowsForDeletion.push(rowForDeletion);
      }
    });
    var unchangedGridData = getUnchangedData(gridData);
    var groups = getMergedData(editedRows, unchangedGridData);
    var transformedMarketListPayload = getTransformedCityAptsListPayload(groups);
    var payloads = buildFinalPayloads(transformedMarketListPayload);
    return savePayload(payloads).then(deleteFromServer(rowsForDeletion));
  }
  function buildFinalPayloads(rows) {
    return _.reduce(rows, function (result, row) {
      result.push(buildPayload(row));
      return result;
    }, []);
  }
  function buildPayload(row) {
    return {
      carrier: getStringValue(row.carrier),
      origin: _.toUpper(row.originAirport),
      destination: _.toUpper(row.destinationAirport),
      city: _.toUpper(row.city),
      airportDetails: row.airportDetails,
      routing: row.routing === undefined || row.routing === '' ? null : row.routing
    };
  }
  function buildPayLoadForRemovalWhileSaving(row) {
    return {
      carrier: _.has(row._old, 'carrier') ? getStringValue(row._old.carrier) : getStringValue(row.carrier),
      origin: _.has(row._old, 'originAirport') ? getStringValue(row._old.originAirport) : getStringValue(row.originAirport),
      destination: _.has(row._old, 'destinationAirport') ? getStringValue(row._old.destinationAirport) : getStringValue(row.destinationAirport),
      city: _.has(row._old, 'city') ? getStringValue(row._old.city) : getStringValue(row.city),
      airportDetails: _.has(row._old, 'airportDetails') ? getStringValue(row._old.airportDetails) : getStringValue(row.airportDetails),
      routing: _.has(row._old, 'routing') ? row._old.routing : row.routing
    };
  }
  function getUnchangedData(gridData) {
    return _.chain(gridData).filter(function (data) {
      return _.isUndefined(data._old);
    }).value();
  }
  function getMergedData(payload, gridData) {
    var payloadGroups = getDataGroupedByKey(payload);
    var gridDataGroups = getDataGroupedByKey(gridData);
    var payloadKeys = Object.keys(payloadGroups);
    var gridDataKeys = Object.keys(gridDataGroups);
    var commonKeys = getCommonKeys(payloadKeys, gridDataKeys);
    commonKeys.forEach(function (key) {
      payloadGroups[key] = payloadGroups[key].concat(gridDataGroups[key]);
    });
    return payloadGroups;
  }
  function getTransformedCityAptsListPayload(groups) {
    return _.chain(_.values(groups)).transform(function (result, cityApts) {
      cityApts[0].airportDetails = getAirportDetails(cityApts);
      result.push(cityApts[0]);
    }, []).value();
  }
  function getAirportDetails(cityAptsList) {
    var uniqueAirports = (0, _toConsumableArray2["default"])(new Set(cityAptsList.map(function (cityApts) {
      return _.toUpper(cityApts.airport);
    })));
    return _.chain(uniqueAirports).map(function (uniqueAiport) {
      return {
        airport: uniqueAiport
      };
    }).value();
  }
  function savePayload(payloads) {
    var promises = [];
    if (payloads && payloads.length) {
      promises.push(saveToServer(payloads));
    }
    return $q.all(promises);
  }
  function saveToServer(payloads) {
    return updateBulkFoCityAptsService.customPUT({
      value: payloads
    });
  }
  function getStringValue(value) {
    return _.isNil(value) || _.isEmpty(value) ? null : value;
  }
  function getCommonKeys(payloadKeys, gridDataKeys) {
    return gridDataKeys.filter(function (gridDataKey) {
      return payloadKeys.includes(gridDataKey);
    });
  }
  function getDataGroupedByKey(data) {
    return _.groupBy(data, function (row) {
      return getCityAptsKey(row);
    });
  }
  function getCityAptsKey(row) {
    return [row.carrier, row.originAirport, row.destinationAirport, row.city, row.routing].filter(function (item) {
      return item !== undefined && item !== null && item !== '';
    }).join('-');
  }
  return {
    exportToCsv: exportToCsv,
    remove: remove,
    validate: validate,
    save: save
  };
};
ConfigurationFoCityAptsService.$inject = ['FileSaveService', 'MomentService', 'ConfigurationService', 'Restangular', '$q', '$http', 'CommonUiConstants', 'AdvancedHepGridReloadConfigurationCacheCityAptsService'];
module.exports = ConfigurationFoCityAptsService;